import { Link } from 'react-router-dom'
import '../styles/Footer.css'

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <div className="d-sm-flex justify-content-center">
                    <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">
                        Copyright ©{new Date().getFullYear()} Festival Greeting.
                        Website developed By{" "}
                        <Link
                            target="_blank"
                            className="text-green hover-white"
                            to="https://www.setblue.com/"
                        >
                            Setblue.com
                        </Link>
                    </span>
                </div>
            </footer>

        </>
    )
}

export default Footer